module.exports = __webpack_public_path__ + "static/media/package-tracking@2x.d1c5d45a.png";